<template>
  <tg-layout>
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <tg-search-tool @on-submit="handleSearch">
          <tg-button
            v-if="
              !isSub &&
              !this.isSearch &&
              this.loaded &&
              $user.permissions[13] > 1
            "
            round
            border
            hoverBorderOnly
            theme="primary"
            @click.native="handleAdd"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-export-p"
                :class="{ active: scope.isHover }"
              ></i>
            </template>
            {{ $t("component.btn.add") }}
          </tg-button>
          <el-input
            :placeholder="$t('column.input_username')"
            v-model="searchData.username"
            class="tg-input input-search-username"
            size="small"
            clearable
          ></el-input>
        </tg-search-tool>

        <el-row
          type="flex"
          v-show="
            $store.state.service.merchantCode == 'AA008' &&
            isDetail &&
            $user.permissions[51] > 1
          "
        >
          <tg-button
            round
            border
            hoverBorderOnly
            theme="info"
            @click.native="handleMemberBatchClick"
          >
            {{ $t("component.btn.bulk_operation") }}
          </tg-button>
        </el-row>
      </el-row>
      <!-- 通路層以及搜尋才顯示 -->
      <el-row v-if="showNote">
        <span>{{ $t("page.member.board.header.note") }}</span>
      </el-row>
    </template>
    <tg-table
      ref="table"
      :columns="currentColumns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      @on-loaded="handleLoaded"
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name
          :row="scope.row"
          :column="scope.column"
          class="as-link"
          @click.native="handleUserClick(scope.value, scope.row)"
        ></tg-user-full-name>
      </template>
      <template v-slot:belows="props">
        <tg-below-cell
          :group="props.row['group']"
          :row="props.row"
          @on-click="handleBelowClick"
        ></tg-below-cell>
      </template>
      <template v-slot:blockedStatus="scope">
        <tg-blocked-status
          v-if="
            scope.row['group'] == 10 ||
            (scope.row['group'] > 10 && scope.column.name == 'loginblocked')
          "
          :blocked="scope.value"
        ></tg-blocked-status>
      </template>
      <template slot="blockedAction" slot-scope="scope">
        <el-row
          v-if="
            scope.row['group'] == 10 ||
            (scope.row['group'] > 10 && scope.column.name == 'login_action')
          "
          type="flex"
          justify="space-around"
          align="middle"
        >
          <tg-blocked-btn
            v-if="scope.row['group'] > 10"
            :action="scope.column.blocked"
            :blocked="scope.row[scope.column.blocked + 'blocked']"
            :targetName="scope.row['username']"
            :isAll="true"
            @on-click="handleActionClick"
          ></tg-blocked-btn>
          <tg-blocked-btn
            :action="scope.column.blocked"
            :blocked="scope.row[scope.column.blocked + 'blocked']"
            :targetName="scope.row['username']"
            :isAll="false"
            @on-click="handleActionClick"
            :disabled="
              (scope.column.blocked == 'login' &&
                scope.row['member_block'] == '3') ||
              (scope.column.blocked == 'bet' &&
                parseInt(scope.row['is_insider']) > 3) ||
              scope.row['authorized'] == '1'
            "
          ></tg-blocked-btn>
        </el-row>
      </template>
      <template slot="handicap_id" slot-scope="scope">
        <el-row
          v-if="scope.row['group'] == 10"
          type="flex"
          justify="space-around"
          align="middle"
        >
          {{ scope.row["handicap_label"] }}
          <span
            v-if="!isSub && $user.permissions[39] > 1"
            class="ma-l-2 clickable"
            @click="
              handleHandicapClick(
                scope.row['handicap_id'],
                scope.row['username']
              )
            "
          >
            <i class="tg-icon tg-icon-openAccount"></i>
          </span>
        </el-row>
      </template>

      <template slot="limit_bet_value" slot-scope="scope">
        <el-row
          v-if="scope.row['group'] == 10"
          type="flex"
          justify="space-around"
          align="middle"
        >
          {{ scope.row["limit_bet_value"] }}
          <span
            v-if="!isSub && $user.permissions[40] > 1"
            class="ma-l-2 clickable"
            @click="
              handleLimitBetClick(
                scope.row['limit_bet_value'],
                scope.row['username']
              )
            "
          >
            <i class="tg-icon tg-icon-openAccount"></i>
          </span>
        </el-row>
      </template>

      <template v-slot:requestTime="props">
        <span :class="{ 'text-red': requestTimeisToday(props.value) }">
          {{ parseReqeustTime(props.value) }}
        </span>
      </template>
    </tg-table>
    <tg-member-board-dialog
      ref="dialog"
      v-bind="dialog"
      @on-success="handleActionSuccess"
    ></tg-member-board-dialog>
    <tg-blocked-dialog
      ref="blockedDialog"
      v-bind="blockedDialog"
      @confirm="updateBlockedStatus"
    ></tg-blocked-dialog>
    <tg-freeze-dialog ref="freezeDialog"></tg-freeze-dialog>
    <tg-handicap-dialog
      ref="handicapDialog"
      v-bind="handicapDialog"
      :title="$t('component.dialog.handicap.title')"
      @confirm="updateHandicap"
    ></tg-handicap-dialog>
    <tg-limit-bet-dialog
      ref="limitBetDialog"
      v-bind="limitBetDialog"
      :title="$t('component.dialog.bet_limit.title')"
      @confirm="updateLimitBet"
    ></tg-limit-bet-dialog>
    <tg-member-batch-dialog
      ref="memberBatchDialog"
      v-bind="memberBatchDialog"
      :title="$t('component.dialog.member_batch.title')"
      @confirm="updateMemberBatch"
    ></tg-member-batch-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgBlockedBtn from "@/components/button/TgBlockedBtn";
import TgBelowCell from "@/components/slot/TgBelowCell";
import TgBlockedStatus from "@/components/slot/TgBlockedStatus";
import TgButton from "@/components/button/TgButton";
import TgMemberBoardDialog from "@/components/dialog/TgMemberBoardDialog";
import TgBlockedDialog from "@/components/dialog/TgBlockedDialog";
import TgFreezeDialog from "@/components/dialog/TgFreezeDialog";
import TgHandicapDialog from "@/components/dialog/TgHandicapDialog";
import TgLimitBetDialog from "@/components/dialog/TgLimitBetDialog";
import TgMemberBatchDialog from "@/components/dialog/TgMemberBatchDialog";

import date from "@/utils/date";
import str from "@/utils/str";
import apis from "@/apis";
const api = apis.member.board;

import { nextGroup } from "@/utils/taogin";

export default {
  components: {
    TgLayout,
    TgTable,
    TgSearchTool,
    TgUserFullName,
    TgBlockedBtn,
    TgBelowCell,
    TgBlockedStatus,
    TgButton,
    TgMemberBoardDialog,
    TgBlockedDialog,
    TgFreezeDialog,
    TgHandicapDialog,
    TgLimitBetDialog,
    TgMemberBatchDialog,
  },
  data() {
    return {
      proxy: api.getData,
      isDetail: false,
      showNote: false,
      columns: [],
      detailColumns: [],
      currentColumns: [],
      searchData: {
        targetName: "",
        username: "",
        mod: "list",
      },
      group: "",
      groupTag: "",
      upperGroupTag: "",
      showStatusBlock: false,
      dialog: {
        title: "",
        show: false,
        dataProxy: null,
        confirmProxy: null,
        params: {},
      },
      clickedUser: null,
      clicked: null,
      blockedDialog: {
        username: "",
        action: "",
        blocked: 0,
        isAll: false,
      },
      loaded: false,
      handicapDialog: {
        items: [],
      },
      limitBetDialog: {
        limit_bet_value: 0,
      },
      memberBatchDialog: {
        items: [],
      },
      hadicapArray: [],
    };
  },
  props: {
    hasUser: Boolean,
  },
  created() {
    if (this.$route.params.username && !this.clickedUser) {
      this.$router.push({ name: "member.board.index" });
    }

    api.getColumns().then((response) => {
      let columns = response.data.columns;

      this.columns = columns;
      this.detailColumns = response.data.detailColumns;
      this.currentColumns = columns;
      this.hadicapArray = response.data.handicap;
      this.memberBatchDialog = {
        items: this.detailColumns.filter((x) => {
          return x.isBatch && x.isBatch === true;
        }),
        hadicapArray: this.hadicapArray,
        username: this.searchData.username ?? this.$user.username,
      };

      if (this.hasUser) {
        this.$nextTick(() => {
          this.$refs.table.init({ targetName: this.$route.params.username });
        });
      } else {
        this.$refs.table.init();
      }
    });
  },
  computed: {
    isSearch() {
      return !!this.searchData.username;
    },
  },
  methods: {
    handleSearch() {
      if (this.clickedUser) {
        this.clickedUser = null;
        this.clicked = null;
        this.$router.push({
          name: "member.board.index",
          params: {
            username: "",
          },
        });
      } else {
        this.loaded = false;
        this.$refs.table.search(this.searchData);
      }
    },
    addBreadcrumb() {
      let upperGroupTag = this.upperGroupTag
        ? this.upperGroupTag
        : "l" + this.clicked.group;

      let title = upperGroupTag
        ? str.format(
            "{0} ({1})",
            this.$t("column." + upperGroupTag),
            this.$route.params.username
          )
        : this.$route.params.username;

      this.$store.commit("breadcrumb/add", {
        id: "member.board.user_" + this.$route.params.username,
        name: "member.board.user",
        query: {
          ...this.$route.query,
        },
        params: {
          username: this.$route.params.username,
        },
        meta: {
          title: title,
        },
      });
    },
    handleLoaded(response) {
      if (response.retcode == 0) {
        let isDetail = response.group == 10;
        this.showNote = response.group != 10;
        if (
          response &&
          response.data &&
          response.data[0] &&
          response.data[0].group == "10"
        ) {
          isDetail = true;
        }
        this.isDetail = isDetail;
        this.group = response.group;
        this.groupTag = response.groupTag;
        this.upperGroupTag = response.upperGroupTag;
        let columns = JSON.parse(
          JSON.stringify(isDetail ? this.detailColumns : this.columns)
        );

        if (this.isSearch) {
          if (this.isSub) {
            columns = [
              this.detailColumns[0],
              this.columns[1],
              ...this.detailColumns.slice(1, 7),
              ...this.columns.slice(2, this.columns.length - 1),
              ...this.detailColumns.slice(7),
            ];
          } else {
            if (!isDetail) {
              columns = [
                this.detailColumns[0],
                this.columns[1],
                ...this.detailColumns.slice(1, 7),
                ...this.columns.slice(3, this.columns.length - 1),
                ...this.detailColumns.slice(7),
              ];
            } else {
              columns = [...this.detailColumns];
            }
          }
        }

        columns[0].langKey = response.groupTag
          ? response.groupTag + "_account"
          : "userfullname";

        this.currentColumns = columns;
        this.loaded = true;
        this.$nextTick(() => {
          if (this.$route.params.username) {
            this.addBreadcrumb(isDetail);
          } else {
            this.$store.commit("breadcrumb/clear");
          }
        });
      }
    },
    handleBelowClick({ row }) {
      let route = "member.board.user";
      this.clicked = row;
      this.clickedUser = row["username"];
      this.searchData.username = "";
      this.$router.push({
        name: route,
        params: {
          username: row["username"],
        },
      });
    },
    handleActionClick(action, status, username, isAll = false) {
      this.blockedDialog = {
        action: action,
        blocked: status,
        username,
        isAll,
      };
      this.$refs.blockedDialog.show();
    },
    updateBlockedStatus(action, status, username, isAll = false) {
      this.$store.commit("TOGGLE_FULL_SCREEN_LOADING", true);
      api
        .updateStatus({
          action,
          status,
          username: username,
          isAll: isAll,
        })
        .then((response) => {
          this.$store.commit("TOGGLE_FULL_SCREEN_LOADING", false);
          if (response.retcode == 201 || response.retcode == 207) {
            this.$message.error(
              this.$t("statusCode[" + response.retcode + "]")
            );
          } else if (response.retcode == 208) {
            //凍結帳號
            this.$refs.freezeDialog.show();
          }
          this.$refs.table.refresh();
        });
    },
    handleHandicapClick(handicap_id, username) {
      this.handicapDialog = {
        items: this.hadicapArray,
        selectedValue: parseInt(handicap_id),
        username: username,
      };
      this.$refs.handicapDialog.show();
    },
    updateHandicap(handicap_id, username, isAll = false) {
      this.$store.commit("TOGGLE_FULL_SCREEN_LOADING", true);
      api
        .updateHandicap({
          handicap_id,
          username: username,
          isAll: isAll,
        })
        .then((response) => {
          this.$store.commit("TOGGLE_FULL_SCREEN_LOADING", false);
          if (response.retcode == 201 || response.retcode == 207) {
            this.$message.error(
              this.$t("statusCode[" + response.retcode + "]")
            );
          } else if (response.retcode == 208) {
            //凍結帳號
            this.$refs.freezeDialog.show();
          }
          this.$refs.table.refresh();
        });
    },
    handleLimitBetClick(limit_bet_value, username) {
      this.limitBetDialog = {
        // value: limit_bet_value,
        username: username,
      };
      this.$refs.limitBetDialog.show();
    },
    updateLimitBet(limit_bet_value, username, isAll = false) {
      this.$store.commit("TOGGLE_FULL_SCREEN_LOADING", true);
      api
        .updateLimitBet({
          limit_bet_value: limit_bet_value,
          username: username,
          isAll: isAll,
        })
        .then((response) => {
          this.$store.commit("TOGGLE_FULL_SCREEN_LOADING", false);
          if (response.retcode == 201 || response.retcode == 207) {
            this.$message.error(
              this.$t("statusCode[" + response.retcode + "]")
            );
          } else if (response.retcode == 208) {
            //凍結帳號
            this.$refs.freezeDialog.show();
          }
          this.$refs.table.refresh();
        });
    },
    handleMemberBatchClick() {
      this.$refs.memberBatchDialog.show();
    },
    updateMemberBatch(row, blockedArray, batchData) {
      let data = [];
      switch (row.name) {
        case "login_action":
          data["item"] = "login";
          data["value"] = blockedArray["login"];
          break;

        case "bet_action":
          data["item"] = "bet";
          data["value"] = blockedArray["bet"];
          break;

        case "transfermoney_action":
          data["item"] = "transfermoney";
          data["value"] = blockedArray["transfermoney"];
          break;

        case "handicap_id":
          data["item"] = "handicap_id";
          data["value"] = batchData["handicap_id"];
          break;

        case "limit_bet_value":
          data["item"] = "limit_bet_value";
          data["value"] = batchData["limit_bet_value"];
          break;

        default:
          break;
      }

      this.$store.commit("TOGGLE_FULL_SCREEN_LOADING", true);
      api
        .updateMemberBatch({
          item: data["item"],
          value: data["value"],
          username: this.clickedUser || this.$user.username, // 要拿到代理的username
        })
        .then((response) => {
          this.$store.commit("TOGGLE_FULL_SCREEN_LOADING", false);
          if (response.retcode == 201 || response.retcode == 207) {
            this.$message.error(
              this.$t("statusCode[" + response.retcode + "]")
            );
          } else if (response.retcode == 208) {
            //凍結帳號
            this.$refs.freezeDialog.show();
          }
          this.$refs.table.refresh();
        });
    },
    parseReqeustTime(value) {
      if (!value) {
        return "";
      }

      let year = date.format(value, "YYYY");
      value = date.format(value, "YYYY-MM-DD");

      if (year < 2018) {
        return "2017-12-31 " + this.$t("enum.before");
      } else {
        return value;
      }
    },
    requestTimeisToday(value) {
      if (!value) {
        return false;
      }

      return date.isSame(date.format(value, "YYYY-MM-DD"), date.today());
    },
    handleAdd() {
      this.dialog.dataProxy = apis.member.getAddInfo;
      this.dialog.confirmProxy = apis.member.action.add;
      let belowGroup = this.group;

      if (!belowGroup) {
        belowGroup = this.clicked
          ? nextGroup(this.clicked.group)
          : nextGroup(this.$user.group);
      }

      this.dialog.params = {
        group: belowGroup,
        username: this.clickedUser || this.$user.username,
        confirmLabel: this.$t("component.btn.add"),
        action: "add",
      };
      let groupTag = "l" + belowGroup;
      this.dialog.title = this.$t("column." + groupTag + "_add");

      this.$nextTick(() => {
        this.$refs.dialog.showDialog();
      });
    },
    handleUserClick(username, row) {
      this.dialog.dataProxy = apis.member.getEditInfo;
      this.dialog.confirmProxy = apis.member.action.update;
      this.dialog.params = {
        group: row.group,
        username: username,
        confirmLabel: this.$t("component.btn.save"),
        action: "edit",
      };
      this.dialog.title =
        this.$t("column.l" + row.group + "_account") + "-" + username;
      this.$nextTick(() => {
        this.$refs.dialog.showDialog();
      });
    },
    handleActionSuccess() {
      this.$refs.table.refresh();
    },
    togglePage(hasUser, route) {
      this.loaded = false;
      if (hasUser) {
        this.clickedUser = route.params.username;
        let searchData = this.searchData;
        if (this.searchData.username) {
          this.searchData.username = "";
        }
        this.$refs.table.search({
          ...searchData,
          targetName: route.params.username,
        });
      } else {
        this.clickedUser = null;
        this.$store.commit("breadcrumb/clear");
        this.$refs.table.init(this.searchData);
      }
    },
  },
  watch: {
    hasUser(val) {
      this.togglePage(val, this.$route);
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.togglePage(to.params.username, to);

    next();
  },
};
</script>
